<template>
    <div class="relative bg-gray-50 border rounded">
        <pre class="p-4 overflow-x-scroll whitespace-pre-wrap break-words font-monospace text-xs"
             :class="heightClass">{{ code }}</pre>
        <btn type="secondary" size="pill" class="absolute top-2 right-2"
            @click="copyCode"
        >
            {{ copied ? "Copied!" : "Copy" }}
        </btn>

        <!-- Hidden textarea for reliable copy -->
        <textarea ref="copyArea" class="sr-only" :value="code" aria-hidden="true"></textarea>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
    code: {
        type: String,
        required: true
    },
    language: {
        type: String,
        default: 'text' // for future compatibility
    },
    height: {
        type: String,
        default: 'h-32' // default to Tailwind h-64 (16rem)
    }
})

const copied = ref(false)
const copyArea = ref(null)

const copyCode = async () => {
    try {
        copyArea.value.focus()
        copyArea.value.select()
        document.execCommand('copy')
        copied.value = true
        setTimeout(() => (copied.value = false), 1500)
    } catch (err) {
        console.error('Copy failed', err)
    }
}

const heightClass = computed(() => props.height)
</script>

<style scoped>
pre {
    overflow-x: auto;
    margin: 0;
    font-family: monospace;
}
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
</style>
